import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CpfCnpjValidator } from 'ngx-cpf-cnpj';
import { AbstractCrudComponent } from '../../../component/abstract-crud.component';
import { ConfirmationDialogComponent } from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from '../../../dialogs/error-dialog/error-dialog.component';
import { InformacaoFechamentoMarcacaoConsultaDTO } from '../../../dtos/informacao-fechamento-marcacao-consulta-dto';
import { MarcacaoDTO } from '../../../dtos/marcacao-dto';
import { RelatorioDTO } from '../../../dtos/relatorio-dto';
import { ResponseDTO } from '../../../dtos/response-dto';
import { Filial } from '../../../filial/filial';
import { FilialService } from '../../../filial/filial.service';
import { FechamentoMarcacao } from '../../../marcacao/fechamento-marcacao';
import { MarcacaoConsulta } from '../../../marcacao/marcacao-consulta/marcacao-consulta';
import { MarcacaoConsultaService } from '../../../marcacao/marcacao-consulta/marcacao-consulta.service';
import { MarcacaoConsultaPK } from '../../../marcacao/marcacao-consulta/pks/marcacao-consulta-pk';
import { Medico } from '../../../medico/medico';
import { MedicoService } from '../../../medico/medico.service';
import { IndTitularPipe } from '../../../pipes/ind-titular-pipe';
import { ProcedimentoConsulta } from '../../../procedimento/procedimento-consulta/procedimento-consulta';
import { ProcedimentoConsultaService } from '../../../procedimento/procedimento-consulta/procedimento-consulta.service';
import { RelatorioConsultaService } from '../../../relatorio/consulta/relatorio-consulta.service';
import { CustomDateValidator } from '../../../validators/custom-date-validator';

@Component({
  selector: 'app-localizar-atendimento-consulta-list',
  templateUrl: './localizar-atendimento-consulta-list.component.html',
  styleUrls: ['./localizar-atendimento-consulta-list.component.css']
})
export class LocalizarAtendimentoConsultaListComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['horaAtendimento', 'nomePaciente', 'indTitular', 'cpf', 'nomePlanoSaude', 'nomeProcedimentoConsulta', 'status', 'detalhe', 'acoes'];

  formularioDeLocalizacaoDeConsulta: FormGroup;

  filtroMarcacao: MarcacaoDTO;

  listaFiliais: Filial[];

  listaMedicos: Medico[];

  listaProcedimentoConsulta: ProcedimentoConsulta[];

  usuarioLogado: ResponseDTO;

  ocultarOpcaoExcluir: boolean = true;

  constructor(private marcacaoConsultaService: MarcacaoConsultaService,
    private filialService: FilialService, private medicoService: MedicoService,
    private procedimentoConsultaService: ProcedimentoConsultaService,
    router: Router, dialog: MatDialog, private formBuilder: FormBuilder,
    private indTitularPipe: IndTitularPipe, private relatorioService: RelatorioConsultaService) {

    super(router, dialog);

    this.filtroMarcacao = history.state.filtroMarcacao;

    this.listaFiliais = [];

    this.listaMedicos = [];

    this.listaProcedimentoConsulta = [];

    this.usuarioLogado = JSON.parse(localStorage.getItem('currentUser') || '{}');

    this.configurarVisibilidadeOpcaoDeExcluir();

    this.formularioDeLocalizacaoDeConsulta = this.formBuilder.group({
      idFilial: ['', [Validators.required]],
      dataMarcacao: [''],
      nomePaciente: ['', [Validators.minLength(3)]],
      cpf: ['', [CpfCnpjValidator.validate]],
      idMedico: [''],
      idProcedimentoConsulta: [''],
    }, {
      validator: CustomDateValidator('dataMarcacao')
    });
  }

  ngOnInit() {

    this.listarFiliais();

    this.listarMedicos();

    this.listarProcedimentoConsulta();

    if (!this.filtroMarcacao) {
      this.filtroMarcacao = new MarcacaoDTO();
    }

    //if (this.filtroMarcacao && this.filtroMarcacao.idFilial && this.filtroMarcacao.dataMarcacao) {
    if (this.filtroMarcacao &&
      (this.filtroMarcacao.idFilial || this.filtroMarcacao.nomePaciente ||
        this.filtroMarcacao.cpf || this.filtroMarcacao.dataMarcacao ||
        this.filtroMarcacao.idMedico || this.filtroMarcacao.idProcedimentoConsulta)) {

      this.formularioDeLocalizacaoDeConsulta.patchValue(this.filtroMarcacao);

      this.reloadData(this.filtroMarcacao);
    }

    super.ngOnInit();
  }

  reloadData(marcacaoDTO: MarcacaoDTO) {

    if (!marcacaoDTO.dataMarcacao && !marcacaoDTO.nomePaciente && !marcacaoDTO.cpf) {

      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Preencha um dos seguintes campos: Data, Paciente ou CPF.'
        }
      });

    } else {

      this.marcacaoConsultaService.procurarMarcacaoConsultaPorFiltroComProjecao(marcacaoDTO)
        .subscribe(data => {
          // console.log(data)

          const listaMarcacoes: Array<MarcacaoDTO> = [];

          data.forEach((element: any) => {
            listaMarcacoes.push(Object.assign(new MarcacaoDTO(), element));
          });

          this.data = listaMarcacoes;

          this.configurarformatacoes(this.data);

          this.configurarDataSource();

        }, error => {
          console.log(error);
        });
    }
  }
  configurarformatacoes
    (data: MarcacaoDTO[]) {

    data.forEach(
      (val, index) => {
        data[index].indTitular = this.indTitularPipe.transform(data[index].cpfTitular);
      });

    return data;
  }

  onSubmit() {
    this.filtroMarcacao = this.formularioDeLocalizacaoDeConsulta.value;

    this.reloadData(this.filtroMarcacao);
  }

  confirmDelete(marcacaoDTO: MarcacaoDTO) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente remover essa informação ?'
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete(marcacaoDTO);
      }
    });
  }

  delete(marcacaoDTO: MarcacaoDTO) {
    this.marcacaoConsultaService.removerMarcacao(marcacaoDTO.getPkConsultaDaEntidade())
      .subscribe(
        data => {
          // console.log(data);

          this.filtroMarcacao = this.formularioDeLocalizacaoDeConsulta.value;

          this.reloadData(this.filtroMarcacao);
        },
        error => {
          console.log(error);
        });
  }

  details(marcacaoDTO: MarcacaoDTO) {

    const filtroAtual: MarcacaoDTO = this.formularioDeLocalizacaoDeConsulta.value;

    this.router.navigate(['detalharMarcacaoConsulta'], {
      state: {
        marcacaoDTO: marcacaoDTO,
        filtroMarcacao: filtroAtual,
        paginaAnterior: 'localizaAtendimentoConsulta',
      }
    });
  }

  imprimirAgendamento(marcacaoDTO: MarcacaoDTO) {

    const relatorioDTO: RelatorioDTO = new RelatorioDTO();
    if (marcacaoDTO.idFilial) {
      relatorioDTO.filial = new Filial();
      relatorioDTO.filial.id = marcacaoDTO.idFilial;
    }
    if (marcacaoDTO.idPaciente) {
      relatorioDTO.idPaciente = marcacaoDTO.idPaciente;
    }
    if (marcacaoDTO.idPlanoSaude) {
      relatorioDTO.idPlanoSaude = marcacaoDTO.idPlanoSaude;
    }
    if (marcacaoDTO.idProcedimentoConsulta) {
      relatorioDTO.idProcedimento = marcacaoDTO.idProcedimentoConsulta;
    }
    if (marcacaoDTO.dataMarcacao) {
      relatorioDTO.dataInicial = marcacaoDTO.dataMarcacao;
    }

    this.relatorioService.gerarRelatorioDeDadosDoAgendamento(relatorioDTO)
      .subscribe((response: BlobPart) => {
        const file = new Blob([response], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      });
  }

  listarFiliais() {
    this.filialService.semRelacionamento()
      .subscribe(data => {
        // console.log(data)
        this.listaFiliais = data;

      }, error => {
        console.log(error);
      });
  }

  cancelar(marcacaoDTO: MarcacaoDTO) {

    if (!marcacaoDTO.motivoCancelamentoMarcacao) {
      this.router.navigate(['cancelarMarcacao'], {
        state: {
          filtroMarcacao: this.formularioDeLocalizacaoDeConsulta.value,
          marcacaoDTO: marcacaoDTO,
          tipoMarcacao: 'TIPO_MARCACAO_CONSULTA',
          paginaAnterior: 'localizaAtendimentoConsulta',
        }
      });
    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Marcação já cancelada!'
        }
      });
    }
  }

  executarAcaoDoStatusSelecionado(marcacaoDTO: MarcacaoDTO): void {

    if (marcacaoDTO) {

      if (marcacaoDTO.status === MarcacaoConsulta.STATUS_AGENDADO) {

        this.fecharMarcacao(marcacaoDTO);

      } else if (marcacaoDTO.status === MarcacaoConsulta.STATUS_CANCELADO) {

        this.irParaTelaDeCancelamento(marcacaoDTO);

      } else if (marcacaoDTO.status === MarcacaoConsulta.STATUS_FINALIZADO) {

        this.irParaTelaDeFechamento(marcacaoDTO);

      }
    }
  }

  fecharMarcacao(marcacaoDTO: MarcacaoDTO): void {

    if (this.usuarioLogado && this.usuarioLogado.username) {
      const fechamentoMarcacao: FechamentoMarcacao = new FechamentoMarcacao();
      fechamentoMarcacao.loginUserFechamento = this.usuarioLogado.username;

      const pk: MarcacaoConsultaPK = marcacaoDTO.getPkConsultaDaEntidade();

      const infoFechamento: InformacaoFechamentoMarcacaoConsultaDTO = new InformacaoFechamentoMarcacaoConsultaDTO();
      infoFechamento.pkMarcacao = pk;
      infoFechamento.fechamentoMarcacao = fechamentoMarcacao;

      this.marcacaoConsultaService.fecharMarcacao(infoFechamento)
        .subscribe(data => {
          // console.log(data)

          this.filtroMarcacao = this.formularioDeLocalizacaoDeConsulta.value;

          this.reloadData(this.filtroMarcacao);

        }, error => {
          console.log(error);
        });

    } else {
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Não será possível fechar a Marcação. Usuário logado não encontrado!'
        }
      });
    }
  }

  irParaTelaDeFechamento(marcacaoDTO: MarcacaoDTO): void {
    this.router.navigate(['informacaoFechamento'], {
      state: {
        filtroMarcacao: this.formularioDeLocalizacaoDeConsulta.value,
        fechamentoMarcacao: marcacaoDTO.fechamentoMarcacao,
        paginaAnterior: 'localizaAtendimentoConsulta',
      }
    });
  }

  irParaTelaDeCancelamento(marcacaoDTO: MarcacaoDTO): void {
    this.router.navigate(['informacaoCancelamento'], {
      state: {
        filtroMarcacao: this.formularioDeLocalizacaoDeConsulta.value,
        motivoCancelamentoMarcacao: marcacaoDTO.motivoCancelamentoMarcacao,
        paginaAnterior: 'localizaAtendimentoConsulta',
      }
    });
  }

  configurarVisibilidadeOpcaoDeExcluir(): void {

    this.ocultarOpcaoExcluir = true;

    if ((this.usuarioLogado && this.usuarioLogado.perfil &&
      (this.usuarioLogado.perfil === 'ROLE_ADMIN' || this.usuarioLogado.perfil === 'ROLE_ROOT')
    ) ||
      this.usuarioLogado.username === 'thayna') {

      this.ocultarOpcaoExcluir = false;

    }
  }

  listarMedicos() {
    this.medicoService.listarComProjecao()
      .subscribe(data => {

        // console.log(data)
        this.listaMedicos = data;

      }, error => {
        console.log(error);
      });
  }

  listarProcedimentoConsulta() {
    this.procedimentoConsultaService.listarComProjecao()
      .subscribe(data => {

        // console.log(data)
        this.listaProcedimentoConsulta = data;

      }, error => {
        console.log(error);
      });
  }
}
